import { fetcher } from '@/data/fetcher';
import {
  DatasetSchema,
  RepoExampleCreateSchema,
  RunSchema,
} from '@/types/schema';
import { apiBulkExamplesPath } from '@/utils/constants';
import {
  convertRunToDatasetExample,
  convertRunToDatasetExampleManualIO,
} from '@/utils/convert-run-to-ds-example';

export async function handleAddToDataset(
  dataset: DatasetSchema,
  selectedRunIds: string[],
  organizationId: string | null
): Promise<
  Response & {
    headers?: Record<string, string> | undefined;
  }
> {
  const jsonData = selectedRunIds
    .map((runId) => {
      return convertRunToDatasetExample(runId, dataset);
    })
    .filter((example) => example !== null);
  const res = await fetcher<Response, never, RepoExampleCreateSchema[]>({
    url: `${apiBulkExamplesPath}`,
    method: 'POST',
    json: jsonData as RepoExampleCreateSchema[],
    resolveWithResponse: true,
    headers: { 'X-Tenant-Id': organizationId },
  });
  return res;
}

export async function handleAddToDatasetManualIO(
  dataset: DatasetSchema,
  io: Pick<RunSchema, 'inputs' | 'outputs' | 'extra' | 'id'>[],
  organizationId: string | null
): Promise<
  Response & {
    headers?: Record<string, string> | undefined;
  }
> {
  const jsonData = io
    .map((run) => {
      return convertRunToDatasetExampleManualIO(run, dataset);
    })
    .filter((example) => example !== null);
  const res = await fetcher<Response, never, RepoExampleCreateSchema[]>({
    url: `${apiBulkExamplesPath}`,
    method: 'POST',
    json: jsonData as RepoExampleCreateSchema[],
    resolveWithResponse: true,
    headers: { 'X-Tenant-Id': organizationId },
  });
  return res;
}
